import { Device, Item, ValidationResult } from "./interfaces/interfaces";

// Función que devuelve el estado de validación
export const validateStatus = (item: Item, devices: Device[]): ValidationResult => {
  const error = devices.find((device) => device.device_status[item.type_frame].status === "error");
  if (error) {
    return {
      type: 3,
      btn: "btn-danger",
      check: "fa-times-circle text-danger"
    };
  }

  const loading = devices.find(
    (device) => device.device_status[item.type_frame].status === "loading"
  );
  if (loading) {
    return {
      type: 1,
      btn: "btn-secondary",
      check: ""
    };
  }

  const done = devices.filter(
    (device) => device.device_status[item.type_frame].status === "done"
  ).length;
  if (done > 0) {
    return {
      type: 2,
      btn: "btn-success",
      check: "fa-check-circle text-success"
    };
  }

  return {
    type: 0,
    btn: "btn-gray",
    check: "fa-circle text-gray"
  };
};

// Función que cuenta dispositivos según estado
export const validateCountStatus = (item: Item, devices: Device[], status?: string): number => {
  return devices.filter((device) =>
    status ? device.device_status[item.type_frame].status === status : true
  ).length;
};

// Función que cuenta por propiedad, con estado opcional
export const validateCountByPropiety = (
  item: Item,
  devices: Device[],
  status: string | undefined,
  propiety: string,
  value: any = true
): number => {
  /*  validateCountByPropiety(item, devices, status, "power"), */
  return devices.filter((device) =>
    status ? device.device_status[item.type_frame].status === status : device[propiety] === value
  ).length;
};

// Filtra dispositivos por propiedad (o todos)
export const validateDevices = (
  devices: Device[],
  prop: string = "",
  value: any = true
): Device[] => {
  return devices.filter((device) => (prop ? device[prop] === value : true));
};
